<!-- 项目信息 -->
<template>
  <div>
    <k-form-build
      :value="jsonData"
      ref="KFB"
    />
  </div>
</template>
<script>
export default {
  name: 'ProjectProtocolNumber',
  data() {
    return {
      jsonData: {
        'list': [
          {
            'type': 'input',
            'icon': 'icon-edit',
            'options': {
              'width': '100%',
              'minRows': 4,
              'maxRows': 6,
              'maxLength': null,
              'defaultValue': '',
              'clearable': false,
              'hidden': false,

              'placeholder': '上次实际开始日期'
            },
            'model': '9d5cd8ed-4127-c4bc-e372-efb16c167ab7',
            'key': '9d5cd8ed-4127-c4bc-e372-efb16c167ab7',
            'rules': [
              {
                'required': false,
                'message': '必填项'
              }
            ]
          }
        ],
        'config': {
          'layout': 'vertical',
          'labelCol': {
            'span': 4
          },
          'wrapperCol': {
            'span': 18
          },
          'hideRequiredMark': false,
          'customStyle': ''
        }
      }
    }
  },
  methods: {},
  mounted() {

  }
}
</script>
